/* @flow */
/* eslint-disable react/destructuring-assignment */

import * as React from 'react';
import { defaults, get, identity } from 'lodash/fp';

type Props = {};

type State = {
  currentPage: number,
  errors: Array<*>,
  hasNextPage: boolean,
  initialised: boolean,
  items: Array<*>,
  lastPage: ?number,
  loading: boolean
};

const defaultConfig = defaults({
  normalizeData: identity,
  normalizeMeta: identity
});

function withAPICollection(options) {
  const config = props => defaultConfig(typeof options === 'function' ? options(props) : options);

  return WrappedComponent =>
    class extends React.Component<Props, State> {
      props: Props;

      state: State = {
        currentPage: 1,
        errors: [],
        hasNextPage: false,
        initialised: false,
        items: [],
        loading: false,
        lastPage: undefined
      };

      handleFetch = (...args) => {
        const { fetcher } = config(this.props);

        this.setState({
          errors: [],
          loading: true
        });

        fetcher(...args).then(this.handleSuccess, this.handleFailure);
      };

      handleSilentFetch = (...args) => {
        const { fetcher } = config(this.props);

        this.setState({
          errors: []
        });

        fetcher(...args).then(this.handleSuccess, this.handleFailure);
      };

      handleSuccess = res => {
        const { normalizeData, normalizeMeta } = config(this.props);

        this.setState({
          currentPage: get('pagination.current_page', res.meta),
          hasNextPage: get('pagination.has_next_page', res.meta),
          initialised: true,
          items: normalizeData(res.data, res.meta),
          meta: normalizeMeta(res.meta),
          lastPage: get('pagination.last_page', res.meta),
          loading: false
        });
      };

      handleFailure = res => {
        this.setState({
          errors: res.errors,
          initialised: true,
          loading: false
        });
      };

      render() {
        return (
          <WrappedComponent
            currentPage={this.state.currentPage}
            errors={this.state.errors}
            hasNextPage={this.state.hasNextPage}
            initialised={this.state.initialised}
            items={this.state.items}
            meta={this.state.meta}
            lastPage={this.state.lastPage}
            loading={this.state.loading}
            onFetch={this.handleFetch}
            onSilentFetch={this.handleSilentFetch}
            {...this.props}
          />
        );
      }
    };
}

export default withAPICollection;
